<template>
    <div>
        <div
            class="help-button"
            @click="
                dialog = true;
                ticket = {
                    id_departamento: 1,
                    id_urgencia: 1,
                };
            "
        >
            <v-icon>mdi-help-circle</v-icon>
        </div>
        <v-dialog v-model="dialog" max-width="80%">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Crear ticket de soporte
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row style="margin-top: 1rem">
                        <v-col cols="12">
                            <v-text-field
                                label="Título"
                                dense
                                outlined
                                v-model="ticket.titulo"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <RichTextComponent
                                uploadUrl="api/soporte-externo/imagen"
                                v-model="ticket.descripcion"
                            ></RichTextComponent>
                        </v-col>
                        <v-col cols="12">
                            <archivosComponent
                                v-model="ticket.archivos"
                            ></archivosComponent>
                        </v-col>
                        <!--v-col cols="12" md="6">
                            <v-autocomplete
                                label="Departamento"
                                outlined
                                dense
                                v-model="ticket.id_departamento"
                                :items="departamentos"
                                item-text="descripcion"
                                item-value="id"
                            >
                            </v-autocomplete>
                        </v!--v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                label="Urgencia"
                                outlined
                                dense
                                v-model="ticket.id_urgencia"
                                :items="urgencia"
                                item-text="descripcion"
                                item-value="id"
                            >
                            </v-autocomplete>
                        </v-col>

                        <v-col-- cols="12">
                            <v-textarea
                                dense
                                outlined
                                height="100px"
                                label="Descripción"
                                v-model="ticket.descripcion"
                            >
                            </v-textarea>
                        </v-col-->
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="saveTicket()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
.help-button {
    cursor: pointer;
    margin-right: 1rem;
}
.help-button .v-icon {
    transition: color 0.5s;
}
.help-button:hover .v-icon {
    color: black;
}
.w-6 {
    width: 2rem;
    height: 2rem;
    margin-top: 5px;
    margin-bottom: 4px;
    color: black;
}
</style>
<script>
import archivosComponent from "../general/ArchivosComponent.vue";
import RichTextComponent from "../general/RichTextComponent.vue";
export default {
    components: {
        archivosComponent,
        RichTextComponent,
    },
    data() {
        return {
            ticket: {
                id_departamento: 1,
                id_urgencia: 1,
            },
            dialog: false,
            departamentos: [],
            urgencia: [],
        };
    },
    created() {
        //this.getDepartamentos();
        //this.getUrgencia();
    },
    methods: {
        saveTicket() {
            axios.post("api/soporte-externo", this.ticket).then((res) => {
                this.dialog = false;
                this.$toast.sucs("Ticket enviado con éxito");
            });
        },
        getDepartamentos() {
            axios.get("api/get-departamentos").then((res) => {
                this.departamentos = res.data.success;
            });
        },
        getUrgencia() {
            axios.get("api/get-urgencia").then((res) => {
                this.urgencia = res.data.success;
            });
        },
    },
};
</script>
